import React, { useEffect, useRef } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { FormRef, SimpleItem } from "devextreme-react/form";
import ILocalisation from "../../models/ILocalisation";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionLocalisationProps {
  isModeSelection?: boolean
}

export default function GestionLocalisation({ isModeSelection }: IGestionLocalisationProps) {
  const localisationFormDataSource = useCustomDataSource<ILocalisation, ILocalisation>({ path: "localisation", primaryKey: "idLocalisation" });
  const { setMainForm, selectedDataRow: selectedInventaire, setSelectedDataRow, mode, onFieldDataChanged, setMode, isFieldModifier, setIsFieldModifier } = localisationFormDataSource;
  const formRef = useRef<FormRef>(null);
  const { setSelectedValue } = useContextPopupPage();

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  return (
    <FormListBase data={localisationFormDataSource}>
      <FormListBaseGrid dataSource={localisationFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedInventaire?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedInventaire || {} as ILocalisation} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <SimpleItem key={"frm-id-description"} dataField={"description"}>
              </SimpleItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedInventaire || {} as ILocalisation} /></TabItem>
        </FormListBaseTab>
        : null}
    </FormListBase>
  );
}